import { FC, ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { RouterPathes } from 'shared/constants'
import { isModeAvailable, ModeName } from './mode-availability'

interface Props {
  mode: ModeName
  /** Where a hidden mode sends the visitor; the query string goes along. */
  fallback?: RouterPathes
  children: ReactNode
}

/**
 * Renders the route of a game mode, or replaces it with `fallback` (the home
 * page by default) while the stand hides that mode, so old links to Meme
 * Wars, Setups and 1vs1 land on a page that works under `offchainOnly`.
 */
export const ModeRoute: FC<Props> = ({
  mode,
  fallback = RouterPathes.home,
  children
}) => {
  const { search } = useLocation()

  if (isModeAvailable(mode)) return <>{children}</>

  return (
    <Navigate
      to={`${fallback}${search}`}
      replace={true}
    />
  )
}
